export {
  completeAutoScalingTerminationLifecycleAction,
  getAutoScalingInstanceLifecycleState,
  waitForAutoScalingTerminationLifecycleAction,
} from './autoscaling.js';
export { makeAwsConfigProvider } from './config.js';
